import styled from 'styled-components'

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  margin: 15px auto;
  align-items: center;
  justify-content: flex-start;
  max-width: 600px;
`
